import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
// 单独引入分页组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import { Pagination } from 'element-ui';
// import { Button } from 'element-ui';
import '@/assets/css/reset.css';
import publicMethods from './common/publicMethods';
import VueScrollReveal from 'vue-scroll-reveal';

Vue.prototype.$axios = axios;
Vue.prototype.$public = publicMethods;
// 挂载动画特效
Vue.use(ElementUI);
// 默认配置 v-scroll-reveal.reset
// 自定义 v-scroll-reveal.reset="{origin: 'bottom'}"
Vue.use(VueScrollReveal, {
    class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
    reset: false,  // 是否重新执行动画
    origin: 'bottom',
    distance: '30px',
    duration: 1000,
    opacity: 0.4,  // 初始透明度
    rotate: {x: 0, y: 0, z: 0}, // 过度到0的初始角度
    easing: 'ease'
});
// 请求服务地址
// axios.defaults.baseURL = 'https://yswy.test.hmmwuliu.net/stage-api'
axios.defaults.baseURL = '/api';
// axios.defaults.baseURL = 'https://hmm4.hmmwuliu.net/api'
Vue.config.productionTip = false;
// Vue.component(Pagination.name, Pagination);
// Vue.component(Table.name, Table);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
